import { Button, Icon } from "@accessdev/arc-ui-react";
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";
import { useLingui } from "@lingui/react";
import { selectors } from "@Src/redux/reducers";
import classNames from "classnames";
import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { ROUTES } from "../../constants";
import GotMobile from "../GotMobile/GotMobile";
import RecommendRetailer from "../RecommendRetailer";
import { isLightColor } from "@Src/utils/color.utils";

function FooterTeaserNav({ program }) {
  useLingui();
  const navigate = useNavigate();
  const userIsAuthenticated = useSelector(selectors.hasAuthenticatedUser);
  const redirectToSavingsCalc = () => {
    navigate(ROUTES.SAVINGS_CALCULATOR_PATH);
  };

  return (
    <div className="Footer-uppernav">
      <div
        className={classNames("Footer-modalContainer", {
          "noUser": !userIsAuthenticated,
          "noMobile": !program.mobile_app_attributes,
          "text-dark": isLightColor(program.program_color),
        })}
      >
        {userIsAuthenticated && (
          <div className="Footer-modal recommend">
            <div className="Footer-modalInfo">
              <div className="Footer-modalInfoHeader">
                <Icon size="lg" className="Footer-modalInfoIcon" icon="store" />
                <h3 className="Footer-modalInfoTitle t-body-large">
                  <Trans>Are you a merchant and want to work with us?</Trans>
                </h3>
              </div>

              <span className="Footer-modalInfoSubtext t-body-small">
                <Trans>Click the link below to fill out a merchant application</Trans>
              </span>
              <RecommendRetailer />
            </div>
          </div>
        )}
        {program.mobile_app_attributes && (
          <div className="Footer-modal gotMobile">
            <div className="Footer-modalInfo">
              <div className="Footer-modalInfoHeader">
                <Icon size="lg" className="Footer-modalInfoIcon" icon="phone_android" />
                <h3 className="Footer-modalInfoTitle t-body-large">
                  <Trans>Got Mobile?</Trans>
                </h3>
              </div>

              <span className="Footer-modalInfoSubtext t-body-small">
                <Trans>Redeem deals directly from your mobile device.</Trans>
              </span>
              <GotMobile buttonClassType="secondary-outlined" />
            </div>
          </div>
        )}
        <div className="Footer-modal save">
          <div className="Footer-modalInfo">
            <div className="Footer-modalInfoHeader">
              <Icon size="lg" className="Footer-modalInfoIcon " icon="attach_money" />
              <h3 className="Footer-modalInfoTitle t-body-large">
                <Trans>How much can I save?</Trans>
              </h3>
            </div>

            <span className="Footer-modalInfoSubtext t-body-small">
              <Trans>See how much you could save.</Trans>
            </span>

            <div className="Footer-btnContainer">
              <Button
                className="Footer-btn"
                displayStyle="secondary-outlined"
                type="button"
                onClick={redirectToSavingsCalc}
                additionalProps={{
                  title: t`See how much you could save.`,
                  role: "link",
                }}
              >
                <Trans>Let's Find Out</Trans>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FooterTeaserNav;
